import React from 'react';
import { Link } from 'react-router-dom';
import './WorkCard.css';

export default function WorkCard(props) {
  let link = "/projekt/" + props.id;
  if (props.websitePath) {  link = props.websitePath; }

  return (
    <div className="work-card">
      <img src={props.imageUrl} alt={props.title} />
      <h3>{props.title}</h3>
      <a href={link} target="_blank" rel="noopener">
        <button>{props.buttonText}</button>
      </a>
    </div>
  );
}
